const ENStrategies = {
	"Nova Estratégia" : "New Strategy",
	"Editar Estratégia": "Edit Strategy",
	"Excluir Estratégia": "Delete Strategy",
	"Mover Estratégia": "Move Strategy",
	"Adicionar Item da SWOT": "Add Item of SWOT",
	"Itens da SWOT": "Items of SWOT",
	"Adicionar Estratégia": "Add Strategy",
	"Estratégia movida com sucesso": "Strategy successfully moved",
	"Erro ao mover estratégia": "Error moving strategy",
	"Nenhuma estratégia encontrada": "No strategy found",
	"Estratégias": "Strategies",
	"Selecione um mapa para ver suas estratégias": "Select a map to see its strategies",
	"Selecione os Itens da SWOT para associar": "Select the Items of SWOT to associate",
	"Estratégia adicionada com sucesso": "Strategy successfully added",
	"Estratégia alterada com sucesso": "Strategy successfully changed",
	"Erro ao adicionar estratégia": "Error adding strategy",
	"Erro ao alterar estratégia": "Error changing strategy",
	"Exclusão de Estratégia": "Delete Strategy",
	"Deseja realmente excluir a estratégia": "Do you really want to delete the strategy",
	"Estratégia excluída com sucesso": "Strategy successfully deleted",
	"Erro ao excluir estratégia": "Error deleting strategy",
	"Alterar Estratégia": "Change Strategy",
	"Item da SWOT adicionado com sucesso": "Item of SWOT successfully added",
	"Objetivo adicionada com sucesso": "Objective successfully added",
	"Erro ao adicionar objetivo": "Error adding objective",
	"Erro ao adicionar item da SWOT": "Error adding item of SWOT",
	"Exclusão de Objetivo": "Delete Objective",
	"Exclusão de Item de SWOT": "Delete Item of SWOT",
	"Deseja realmente excluir o objetivo": "Do you really want to delete the objective",
	"Deseja realmente excluir este item da SWOT": "Do you really want to delete this item of SWOT",
	"Objetivo excluído com sucesso": "Objective successfully deleted",
	"Item da SWOT excluído com sucesso": "Item of SWOT successfully deleted",
	"Erro ao excluir objetivo": "Error deleting objective",
	"Erro ao excluir item da SWOT": "Error deleting item of SWOT",
	"Adicionar Objetivo": "Add Objective",
	"Nenhum objetivo cadastrado": "No objective registered",
	"Adicione um objetivo para visualizá-lo": "Add an objective to see it",
	"Nenhum item da SWOT cadastrado": "No item of SWOT registered",
	"Nome da estratégia não confere": "Strategy name does not match",
	"Adicione um item para visualizá-lo": "Add an item to see it",
	"A pontuação é dada pela multiplicação dos pontos da importância, da intensidade e da tendência": "The score is given by the multiplication of the importance, intensity and tendency points",
	"A pontuação é dada pela multiplicação dos pontos da importância, da urgência e da tendência": "The score is given by the multiplication of the importance, urgency and tendency points"
};

export default ENStrategies;
